<template>
  <div style="height: 100%">
    <div style="margin-top: 0; height: 92%" v-if="dataList.length > 0">
      <div class="row-item" v-for="item in dataList" :key="item.id">
        <div class="left">{{ item.createTime }}</div>
        <div class="right" v-html="item.controlCotent"></div>
      </div>
    </div>
    <div style="margin-top: 0; height: 92%;display: flex;align-items: center;justify-content: center;border: 1px solid #01c5f3" v-else>
      暂无数据
    </div>
    <div style="height: 5%; float: right;margin-top: 10px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryParams.pageNum"
        :background="false"
        :page-size="queryParams.pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  props: {
    form: Object
  },
  data() {
    return {
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      dataList: [],
    };
  },
  created() {
    this.getList();

  },
  methods: {
    getList() {
      api.getControlList().then((res) => {
        this.dataList = res.rows;
        this.total = res.total;
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.queryParams.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.row-item {
  display: flex;
  color: #fff;
  margin: 0 0 0.07rem;
  border: 1px solid #01c5f3;
  .left {
    padding: 0.1rem 0;
    width: 20%;
    text-align: center;
    background: linear-gradient(
      to right,
      rgba(0, 205, 252, 0.8),
      rgba(11, 38, 76, 0.4)
    );
  }
  .right {
    padding: 0.1rem 0;
    width: 80%;
  }
}
 .row-item:nth-child(1){
        margin-top: 0;
    }
::v-deep .el-pager li{
  background: transparent;
  color: #fff;
  &:hover{
    color: #0c9fe1;
  }
}
::v-deep .el-pagination .btn-next, ::v-deep .el-pagination .btn-prev{
  background: transparent;
  color: #FFF;
}
::v-deep .el-pagination__total {
  color: #FFF;
  font-size: 0.1rem;
}
::v-deep(.el-pagination__jump){
  color: #FFF;
}
::v-deep(.el-pagination.is-background .el-pager li:not(.disabled).active){
  background-color: #0874A4;
  //#062349
}
::v-deep(.el-pagination.is-background .btn-prev),
::v-deep(.el-pagination.is-background .btn-next),
::v-deep(.el-pagination.is-background .el-pager li){
  background-color: #062349;
  color: #FFF;
}
::v-deep(.el-pagination.is-background .el-pager li:not(.disabled):hover){
  color: #0c9fe1;
}
::v-deep(.el-pagination .btn-next .el-icon) ,::v-deep(.el-pagination .btn-prev .el-icon){
  font-size: 0.1rem;
}
::v-deep(.el-pager li){
  font-size: 0.1rem;
}

</style>
